// Private helpers shared across trusstor/* modules. Not re-exported from the public barrel.

import { z } from 'zod';

/**
 * Accepts Date objects or ISO 8601 datetime strings, always outputs Date.
 */
export const dateField = z
	.union([z.iso.datetime(), z.date()])
	.transform((val) => (typeof val === 'string' ? new Date(val) : val));

export const nullableDateField = z
	.union([z.iso.datetime(), z.date()])
	.nullable()
	.transform((val) => (typeof val === 'string' ? new Date(val) : val));

export const latLonSchema = z.object({
	latitude: z.number(),
	longitude: z.number(),
});
